"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#24292E' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.3035 4.69693C14.2546 3.64797 12.9182 2.9336 11.4634 2.64416C10.0085 2.35472 8.50048 2.5032 7.13 3.07084C5.75952 3.63847 4.58815 4.59976 3.76402 5.83314C2.93988 7.06651 2.5 8.51658 2.5 9.99996C2.5 11.4833 2.93988 12.9334 3.76402 14.1668C4.58815 15.4002 5.75952 16.3614 7.13 16.9291C8.50048 17.4967 10.0085 17.6452 11.4634 17.3558C12.9182 17.0663 14.2546 16.3519 15.3035 15.303C16.7098 13.8965 17.4999 11.989 17.4999 9.99996C17.4999 8.01096 16.7098 6.10342 15.3035 4.69693ZM13.5837 8.21441L9.39275 12.4054C9.31028 12.4877 9.19855 12.5339 9.08206 12.5339C8.96557 12.5339 8.85384 12.4877 8.77138 12.4054L6.41827 10.0534C6.3759 10.0129 6.34206 9.9644 6.31872 9.91066C6.29538 9.85693 6.28302 9.79907 6.28237 9.74049C6.28171 9.68191 6.29278 9.62379 6.31491 9.56954C6.33705 9.5153 6.3698 9.46603 6.41125 9.42463C6.4527 9.38323 6.50201 9.35053 6.55628 9.32846C6.61055 9.30639 6.66869 9.2954 6.72727 9.29612C6.78585 9.29685 6.84369 9.30928 6.8974 9.33268C6.95111 9.35608 6.9996 9.38999 7.04001 9.4324L9.08262 11.475L12.9623 7.59341C13.0028 7.551 13.0513 7.51709 13.105 7.49369C13.1587 7.47029 13.2165 7.45786 13.2751 7.45713C13.3337 7.45641 13.3918 7.46741 13.4461 7.48947C13.5003 7.51154 13.5497 7.54424 13.5911 7.58564C13.6326 7.62704 13.6653 7.67631 13.6874 7.73055C13.7096 7.7848 13.7206 7.84292 13.72 7.9015C13.7193 7.96008 13.707 8.01794 13.6836 8.07168C13.6603 8.12541 13.6261 8.17394 13.5837 8.21441Z",
    fill: fill
  }));
};

exports["default"] = _default;